import React, { Component } from 'react'
import Grid from '@material-ui/core/Grid'
import { makeStyles } from '@material-ui/core/styles'

import { connect } from 'react-redux'
import {
  uploadS3ZoomProgress,
  loadCoursesUserData,
  loadCoursesUserDataStart
} from '../../actions/'

import { CSVLink, CSVDownload } from 'react-csv'

import {
  loadGroupCategories,
  loadGroupMemberships,
  loadGroupCategoriesGroups
} from '../../services/saga'

import Button from '@material-ui/core/Button'

import DescriptionIcon from '@material-ui/icons/Description'
import BrowserStore from 'store'
import LinearProgress from '@material-ui/core/LinearProgress'
import Typography from '@material-ui/core/Typography'
import Alert from '@material-ui/lab/Alert'

import { saveAs } from 'file-saver'
import XlsxPopulate from 'xlsx-populate'

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 200
  },

  chip: {
    margin: theme.spacing(0.5)
  }
}))

class CourseStudentsExportStepThree extends Component {
  constructor(props) {
    super(props)
    this.csvLinkEl = React.createRef()

    this.state = { groupCategories: [], groupUsers: [], categoryGroups: [] }
  }

  componentDidMount = async () => {
    const { data, getStudents } = this.props

    // loadCoursesUserData(data.courseId);

    if (data.withGroups) {
      let groupCategories = await loadGroupCategories({
        courseID: data.courseId
      })

      if (groupCategories.data.length != 0) {
        let cat = [...groupCategories.data, ...this.state.groupCategories]
        this.setState({ groupCategories: cat })
      }

      if (groupCategories.status === 200) {
        for (let i = 0; i < groupCategories.data.length; i++) {
          let categoryGroups = await loadGroupCategoriesGroups(
            groupCategories.data[i].id
          )

          if (categoryGroups.length != 0) {
            let cat = [...categoryGroups, ...this.state.categoryGroups]
            this.setState({ categoryGroups: cat })
          }

          for (let k = 0; k < categoryGroups.length; k++) {
            let groupMembers = await loadGroupMemberships(categoryGroups[k].id)

            if (groupMembers.length != 0) {
              let ex = [...groupMembers, ...this.state.groupUsers]

              this.setState({ groupUsers: ex })
            }
          }
        }
      }
    }

    getStudents({ courseId: data.courseId })
  }

  getSheetData = (data, header) => {
    var fields = Object.keys(data[0])
    var sheetData = data.map(function (row) {
      return fields.map(function (fieldName) {
        return row[fieldName] ? row[fieldName] : ''
      })
    })
    sheetData.unshift(header)
    return sheetData
  }

  downloadReport = async (dataSet, courseId, withGroups, option = 'slow') => {
    // if (option === 'quick') {
    //   this.csvLinkEl.current.link.click();
    // } else {
    //   setTimeout(() => {
    //     this.csvLinkEl.current.link.click();
    //   }, 1000);
    // }

    const data = dataSet
    let header = [
      'Name',
      'Login',
      'SIS ID/ PeoplesoftID',
      'Section',
      'Groups',
      'Role',
      'Last Activity'
    ]

    if (withGroups == false) {
      header = [
        'Name',
        'Login',
        'SIS ID/ PeoplesoftID',
        'Section',
        'Role',
        'Last Activity'
      ]
    }

    XlsxPopulate.fromBlankAsync().then(async (workbook) => {
      const sheet1 = workbook.sheet(0)
      const sheetData = this.getSheetData(data, header)
      const totalColumns = sheetData[0].length

      sheet1.cell('A1').value(sheetData)
      const range = sheet1.usedRange()
      const endColumn = String.fromCharCode(64 + totalColumns)
      sheet1.row(1).style('bold', true)
      sheet1.range('A1:' + endColumn + '1').style('fill', 'BFBFBF')
      range.style('border', true)
      return workbook.outputAsync().then((res) => {
        saveAs(res, `course-${courseId}-students-data.xlsx`)
      })
    })
  }

  render() {
    const { data, uploadRequest } = this.props

    console.log('kalana', data)

    let finalCsv = []

    let uploadingStatus = data.users.loading
    let textStatus = 'Fetching data please wait'

    if (uploadingStatus === false) {
      const sectionsData = data.data.sections

      let categoryGroups = this.state.categoryGroups.map((catGroup) => {
        let groupCategoryName = this.state.groupCategories.filter(
          (gpCat) => gpCat.id === catGroup.group_category_id
        )

        if (groupCategoryName.length === 1) {
          groupCategoryName = groupCategoryName[0]
        }

        return { ...catGroup, groupCategoryName }
      })

      let userGroupsFinal = this.state.groupUsers.map((groupItem) => {
        let groupName = categoryGroups.filter(
          (gpName) => gpName.id === groupItem.group_id
        )

        if (groupName.length === 1) {
          groupName = groupName[0]
        }

        return { ...groupItem, groupName }
      })

      finalCsv = data.users.data.map((item) => {
        let enrollments = item.enrollments.map((enItem) => {
          let sectionName = sectionsData.filter(
            (sectionItem) => sectionItem.id === enItem.course_section_id
          )

          return { ...{ ...enItem, section_name: sectionName[0].name } }
        })

        let userGroups = userGroupsFinal.filter(
          (groupItem) => item.id === groupItem.user_id
        )

        return { ...item, enrollments, userGroups }
      })

      console.log(finalCsv)

      finalCsv = finalCsv.map((item) => {
        let section = item.enrollments
          .map((enItem) => enItem.section_name)
          .join(',')

        let last_activity_at = item.enrollments
          .map((enItem) => enItem.last_activity_at)
          .join(',')

        let selectedItems = {}

        if (data.withGroups) {
          selectedItems = {
            Name: item.name,
            Login: item.login_id,
            'SIS ID/ PeoplesoftID': item.integration_id,
            Section: section,
            Groups: item.userGroups
              .map(
                (gg) =>
                  `${gg.groupName.name}_${gg.groupName.groupCategoryName.name}`
              )
              .join(','),
            Role: 'Student',
            'Last Activity': last_activity_at
          }
        }

        if (data.withGroups === false) {
          selectedItems = {
            Name: item.name,
            Login: item.login_id,
            'SIS ID/ PeoplesoftID': item.integration_id,
            Section: section,
            Role: 'Student',
            'Last Activity': last_activity_at
          }
        }

        return { ...selectedItems }
      })

      this.downloadReport(finalCsv, data.courseId, data.withGroups)
    }

    return (
      <React.Fragment>
        <p>
          {uploadingStatus == true ? (
            <LinearProgress />
          ) : (
            <Alert severity='success'>
              <p style={{ margin: 0 }}>
                Student data successfully downloaded, If not please
                <span
                  onClick={() => {
                    this.downloadReport(
                      finalCsv,
                      data.courseId,
                      data.withGroups
                    )
                  }}
                  style={{
                    marginLeft: 5,
                    marginRight: 5,
                    cursor: 'pointer',
                    backgroundColor: '#015548',
                    color: '#fff',
                    padding: 2
                  }}
                >
                  Click Here{' '}
                </span>
              </p>
            </Alert>
          )}
        </p>
        <Grid container spacing={3}>
          {uploadingStatus == false ? (
            <div>
              <Button
                style={{
                  marginTop: '30px',
                  marginBottom: '30px'
                }}
                variant='outlined'
                size='large'
                color='primary'
                onClick={() => window.location.reload(false)}
              >
                Back to Home
              </Button>{' '}
            </div>
          ) : (
            <Button>
              Downloading.. Excel export will download automatically. Don't
              close the browser.
            </Button>
          )}

          {/* <CSVLink
            filename={`course-${data.courseId}-students-data.csv`}
            data={finalCsv}
            ref={this.csvLinkEl}
          /> */}

          <div></div>
        </Grid>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state) => ({
  data: state.CourseStudentExport
})
const mapDispatchToProps = (dispatch) => ({
  getStudents: (courseId) => {
    dispatch(loadCoursesUserData(courseId))
  }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CourseStudentsExportStepThree)
